import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "detail-title" }
const _hoisted_2 = { class: "detail-refuse" }
const _hoisted_3 = {
  key: 0,
  class: "tips"
}
const _hoisted_4 = { class: "text-rt" }

import { ref, reactive } from 'vue'
import { exportFileDownload } from '@/util/useExport'
import { t } from '@/plugins/i18n'
import axios from 'axios'
import { useStore } from 'vuex'
import { isEN, isMultiStore } from '@/store'
import { FormInstance, ElMessage } from 'element-plus'
import { getCountryCurrency } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  props: ['currencyCode'],
  setup(__props, { expose }) {

const props = __props

const form: any = reactive({
  requestAmount: '',
  requestName: ''
})
const formRule: any = {
  requestName: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  requestAmount: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ]
}
const visible = ref(false)
const payChannel = ref('')
const formRef = ref<FormInstance>()
const store = useStore()
let downloadLoading = false
const changePrice: any = (row: any) => {
  const num = form.requestAmount.toString().match(/^\d*(\.?\d{0,2})/g)[0]
  form.requestAmount = num
}
const submit = (row: any) => {
  if (!formRef.value) return
  formRef.value.validate((valid) => {
    if (valid) {
      downloadLoading = true
      axios({
        method: 'post',
        url: process.env.VUE_APP_URL + '/settlement/recharge/manager/balance/request/pdf',
        data: {
          payChannel: payChannel.value,
          requestName: form.requestName,
          requestAmount: form.requestAmount,
          //   添加币种 默认CNY
          currencyCode: isMultiStore() ? props.currencyCode : 'CNY'
        },
        responseType: 'blob',
        headers: {
          'X-AuthToken': store.getters.token,
          'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
          'X-Platform': 'PC',
          'X-Appname': 'ckb-client-pc'
        }
      }).then((res: any) => {
        exportFileDownload(res, { type: 'application/pdf', name: t('请求书下载') })
        close()
      }).finally(() => { downloadLoading = false })
    } else {
      return false
    }
  })
}
const close = () => {
  visible.value = false
  formRef.value.resetFields()
}
const open = (status: any) => {
  console.log(status)
  payChannel.value = status
  visible.value = true
}
expose({ open })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": "",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    "custom-class": "down-load-dialog",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('请求书下载')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          "label-width": "160px",
          model: _unref(form),
          rules: formRule,
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            formRef.value = _value
          },
          style: {"max-width":"460px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('请求对象姓名'),
              prop: "requestName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"250px"},
                  modelValue: _unref(form).requestName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).requestName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('请求金额')+'('+ _unref(getCountryCurrency)() +')',
              prop: "requestAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"250px"},
                  modelValue: _unref(form).requestAmount,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).requestAmount) = $event)),
                  onInput: changePrice
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_unref(isEN)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "*This document is a receipt provided to you by our company, please don't upload it as the payment document, financial department will not approve it."))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "default",
          onClick: close,
          class: "btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          class: "btn",
          loading: _unref(downloadLoading)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('提交并下载')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})